import { CollectionConfig } from "@rebasepro/types";

const leadMagnetSignupsCollection: CollectionConfig = {
    name: "Descargas de recursos",
    singularName: "Descarga de recurso",
    slug: "lead-magnet-signups",
    table: "lead_magnet_signups",
    securityRules: [
        {
            // `roles` are application roles read from auth.roles(); an
            // anonymous visitor holds none, so the old `roles: ["anon"]`
            // (a Supabase pgRole habit) compiled to a condition nobody could
            // satisfy and the public form's insert was denied.
            name: "public_insert",
            operation: "insert",
            access: "public"
        },
        {
            // Inbound marketing leads: write-only for the public form, readable
            // by staff. No end user has any reason to read this table.
            name: "admin_full_access",
            operation: "all",
            roles: ["admin"]
        }
    ],
    properties: {
        id: {
            name: "ID",
            type: "string",
            isId: "uuid"
        },
        name: {
            name: "Nombre",
            type: "string",
            validation: {
                required: true
            }
        },
        email: {
            name: "Email",
            type: "string",
            validation: {
                required: true
            }
        },
        resource: {
            name: "Recurso",
            description: "Qué recurso descargó",
            type: "string",
            defaultValue: "guia-salarios-esg-2026"
        },
        created_at: {
            name: "Creado",
            type: "date",
            autoValue: "on_create"
        }
    },
    admin: {
        group: "Captación",
        icon: "Download",
        sort: ["created_at", "desc"],
        listProperties: ["name", "email", "resource", "created_at"],
        previewProperties: ["name", "resource"],
        // Fuera del menú: 0 filas desde que existe. La captación por
        // descarga de guías nunca llegó a usarse, y una entrada
        // permanentemente vacía enseña a ignorar el menú. Quitar esta
        // línea la devuelve.
        hideFromNavigation: true
    }
};

export default leadMagnetSignupsCollection;
